<template>
    <div>
        <details v-if="syllabusSummary.count" class="mt-3 sm:col-span-12">
            <summary>
                <h2 class="inline-block text-lg leading-6 font-medium text-gray-900 mb-3">
                    {{ $t('messages.syllabus') }}
                </h2>
            </summary>

            <div v-for="(category, index) in syllabusSummary.categories" class="flex flex-col mt-5">
                {{ category.name }}
                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div
                        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                    >
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                                <tr>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $tc('messages.dimensions', 2) }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                    v-for="dimension in category.dimensions"
                                >
                                    <td
                                        class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                    >
                                        <BadgePill v-if="showCounters">
                                            {{ dimension.counter }}
                                        </BadgePill>
                                        {{ dimension.abbreviation }} -
                                        {{ dimension.name }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </details>
    </div>
</template>

<script>
import BadgePill from '@/components/BadgePill.vue';

export default {
    name: 'SyllabusSummary',
    components: {
        BadgePill,
    },
    props: {
        summary: {
            required: true,
        },
        showCounters: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            syllabusSummary: this.summary,
        };
    },
};
</script>
